<template>
    <div class='max-w-screen-md w-full
                m-auto
                px-3 pt-2 mt-0 md:py-2 md:mt-2
                bg-gray-50
                text-gray-700
                border rounded border-gray-200
                
                container justify-center'
         id='div_main'>
            <div class="px-4 bg-gray-200 border border-gray-400
                         h-1/4 rounded
                         hover:shadow transition-all duration-100
                       ">
               <div class="container text-xl
                           text-left text-gray-800
                         ">
                    Online photo perspective correction
                </div>
            </div>
            <div class="text-left text-sm pb-10">
                <p>
                    Taking a photo from an angle will turn rectangular objects (like screens, documents, cards) into trapezium. Use this tool to undo the distortion by selecting four corners of the rectangular object before running the correction tool. This tool assembles a 4D perspective transformation matrix using the given corners and applies it to the input image.
                </p>
            </div>
            <CVMain />
    </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
import CVMain from './components/CVMain.vue'


export default {
    name: 'App',
    components: {
        //HelloWorld
        CVMain
    }
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /* margin-top: 60px; */
    /* border : 1px solid red; */
}

</style>

<style scoped>

</style>